import React from 'react'

import Project from "../../models/Project";
import AdminListView from "./components/AdminListView";
import {useLocation, useNavigate} from "react-router-dom";

class AdminProjectsList extends AdminListView
{
    static path = '/client/manager/projects';

    static modelClass() {
        return Project
    }
    static FailedEventName = 'Project.ClientManager@FetchAllForClientManagerFailed';
    static SuccessEventName = 'Project.ClientManager@FetchAllForClientManagerUpdated';
    static modelName = 'Project';
    static searchPlaceholder = 'Search by project name, client, or service';
    static FetchAllRequest() {
        return Project?.FetchAllForClientManagerRequest
    };

    async fetchResultsForParams(params, refresh) {
        return Project?.fetchAllForClientAdmin(params, refresh)
    };

    static statusOptions() {
        return Project?.statusFlatLookup()
    }

    async viewProject(project)
    {
        await TB.auth().startClientSession(project.client);

        this.props.navigate(project.detailLink(), {replace: true});
    }

    listHeaders()
    {

        return [
            this.sortedHeader('Name', 'name'),
            this.sortedHeader('Client', 'clients'),
            this.sortedHeader("Type/Service", 'services'),
            this.sortedHeader("Estimate", 'estimated_cost'),
            this.sortedHeader("Actual Cost", 'actual_cost'),
            'Status',
            this.sortedHeader('Created', 'created_at'),
            "Current Step"
        ]
    }

    listDetails(project)
    {
        return (
            <tr key={`project-${project.id}`}>
                <td>
                    {project.name}
                </td>
                <td>
                    {project.client.name}
                </td>
                <td>
                    {project.displayType()}
                </td>
                <td>
                    {project.estimated_cost ? TB.formatCurrency(project.estimated_cost) : '--'}
                </td>
                <td>
                    {project.actual_cost ? TB.formatCurrency(project.actual_cost) : '--'}
                </td>
                <td>
                    {project.status}
                </td>
                <td>
                    {TB.moment(project.created_at).format('ll')}
                </td>
                <td>
                    <button onClick={() => {
                        this.viewProject(project)
                    }}
                            className={`project-panel-steps-btn btn btn-${project.statusClass()} btn-block`}>
                        {project.panelViewButtonTitle()}
                    </button>
                </td>
            </tr>
        )
    }
}

const ClientAdminProjectList = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    return <AdminProjectsList navigate={navigate} location={location}/>
}

export default ClientAdminProjectList;